import React from 'react';

interface ImageProps {
  data: {
    src?: string;
    alt?: string;
    link?: string;
    objectFit?: string;
    borderRadius?: string;
    lazy?: boolean;
    [key: string]: unknown;
  };
  styles?: string;
}

export const Image: React.FC<ImageProps> = ({ data, styles: _styles }) => {
  const { src, alt = 'Image description', link, objectFit = 'cover', borderRadius = '0', lazy = true } = data ?? {};
  
  const imageContent = (
    <div
      className="h-64 flex items-center justify-center overflow-hidden"
      style={{ borderRadius, backgroundColor: 'var(--style-img-bg, var(--surface-2, #e5e7eb))' }}
    >
      {src ? (
        <img 
          src={src} 
          alt={alt} 
          className="w-full h-full"
          style={{ objectFit: objectFit as React.CSSProperties['objectFit'] }}
          loading={lazy ? 'lazy' : 'eager'}
        />
      ) : (
        <span className="text-[var(--text-secondary)]">📷 {alt}</span>
      )}
    </div>
  );
  
  return (
    <div className="">
      {link ? <a href={link}>{imageContent}</a> : imageContent}
    </div>
  );
};
